import {PatientCGStatus} from '@drl/shared/utility/patients-caregiver-utility.enum';
import {Gender} from '@drl/core/auth/models/gender.enum';

export class PatientCgEhr {
  id?: number;
  patientExtId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  status?: PatientCGStatus;
  dob?: string;
  gender?: Gender;
  roleId: number;
  email?: string;
  comorbidities: string;
  diagnosisCode: string;
  caregiverFirstName: string;
  caregiverMiddleName: string;
  caregiverLastName: string;
  caregiverRelation: string;
  caregiverPhone: string;
  caregiverEmail: string;
}
